<template>
    <div>
        <!-- Switch Input -->
        <label :for="idInput" class="switch">
            <input :id="idInput" type="checkbox" v-model="isToggled" @change="handleChange">
            <span class="slider"></span>
        </label>
        
        <!-- Display the state -->
        <p class="mb-0" id="legenda">
            {{ actionName }}
        </p>
    </div>
</template>

<script>
export default {
    name: "Interruptor",
    props: {
        idInput: {
            type: String,
            default: "",
        },
        actionName: {
            type: String,
            default: "",
        },
        value: {
            type: Boolean,
            default: false // Estado inicial vindo de fora
        },
    },
    data() {
        return {
            isToggled: this.value // Estado do interruptor inicializado com a prop 'value'
        };
    },

    watch: {
        // Atualiza o estado do interruptor se o valor da prop mudar externamente
        value(newVal) {

            setTimeout(() => {
                this.isToggled = newVal;
            }, 100);
            
        }
    },

    methods: {
        handleChange() {
            // Emitir um evento com o novo estado
            this.$emit('input', this.isToggled);
            this.$emit('toggle-change', this.isToggled); // Emissão adicional se necessário
        }
    }
};
</script>

<style scoped>
/* Estilo do interruptor reduzido */
.switch {
    position: relative;
    display: inline-block;
    width: 36px;  /* 60px reduzido em 40% */
    height: 20px; /* 34px reduzido em 40% */
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 20px; /* Ajustado para manter a proporção */
}

.slider:before {
    position: absolute;
    content: "";
    height: 15.6px; /* 26px reduzido em 40% */
    width: 15.6px;  /* 26px reduzido em 40% */
    left: 2.4px;    /* 4px reduzido em 40% */
    bottom: 2.4px;  /* 4px reduzido em 40% */
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:checked + .slider:before {
    transform: translateX(16px); /* 26px reduzido em 40% */
}
</style>
